import { Card, Stack, Typography, Box } from "@mui/joy";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import GradeRoundedIcon from "@mui/icons-material/GradeRounded";
import { getTextExamStatus } from "app/components/ExamStatus/utils/useExamStatus";

const CardInfoSubmission = ({ exam, isDueDatePassed, hasSubmission, currentUserSubmission }) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      sx={{ mb: 4 }}
    >
      {[
        {
          title: "Exam Date",
          value: exam.examTime || "No Deadline",
          icon: <EventRoundedIcon sx={{ fontSize: 40 }} />,
          bgColor: "#FFE0B2",
          titleColor: "#BF360C",
          valueColor: isDueDatePassed ? "#FF0000" : "#BF360C",
        },
        {
          title: "Status",
          value: hasSubmission
            ? getTextExamStatus(exam.status)
            : "Not Submitted",
          icon: <AssignmentTurnedInRoundedIcon sx={{ fontSize: 40 }} />,
          bgColor: "#B3E5FC",
          titleColor: "#003F72",
          valueColor: "#003F72",
        },
        {
          title: "My Score",
          value:
            currentUserSubmission?.score
              ? currentUserSubmission.score?.toFixed(2)
              : "-",
          icon: <GradeRoundedIcon sx={{ fontSize: 40 }} />,
          bgColor: "#C8E6C9",
          titleColor: "#003300",
          valueColor: "#003300",
        },
      ].map((card, index) => (
        <Card
          key={index}
          sx={{
            flex: 1,
            position: "relative",
            background: card.bgColor,
            border: "none",
            overflow: "hidden",
            width: { xs: "100%", sm: "auto" },
            mb: { xs: 2, sm: 0 },
            minHeight: { xs: "100px", sm: "120px" },
            p: { xs: 2, sm: 3 },
          }}
        >
          <Typography
            level="title-lg"
            sx={{
              mb: 2,
              color: card.titleColor,
              fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
            }}
          >
            {card.title}
          </Typography>
          <Typography
            level="h4"
            sx={{
              color: card.valueColor,
              fontSize: { xs: "1.25rem", sm: "1.5rem", md: "2rem" },
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "break-space",
            }}
          >
            {card.value}
          </Typography>
          <Box
            sx={{
              position: "absolute",
              bottom: "8%",
              right: "15%",
              opacity: 0.15,
              transform: "scale(2.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {card.icon}
          </Box>
        </Card>
      ))}
    </Stack>
  );
};

export default CardInfoSubmission;
